import React from "react";
import { useSelector } from "react-redux";

import { ToastList } from "shared/components/Toast/components";
import { toastListSelector } from "shared/components/Toast/state";

export const Toasts: React.FC = () => {
  const toastList = useSelector(toastListSelector);

  return <ToastList toastList={toastList} />;
};
